module.exports = __webpack_public_path__ + "img/case-logo-14.a5c959ca.png";